/** @format */

export const DEFAULT_TEST_ID = 'kit-card';

export enum KitCardLayout {
    STACKED = 'stacked',
    INLINE = 'inline',
}
